const humanFileSize = (bytes, si = true, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

const getQueryStringParams = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {})
    : {};
};

const loadRemoteResource = async (type, url) => {
  return new Promise(function (resolve, reject) {
    // IF resource already exists, early return
    if (document.getElementById(url)) resolve("");

    if (type == "text/css") {
      const link = document.createElement("link");
      link.id = url;
      link.rel = "stylesheet";
      link.href = url;
      document.head.appendChild(link);
      link.onload = function () {
        resolve("");
      };
    }

    if (type == "text/javascript") {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.id = url;
      document.head.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
    }
  });
};

const getSuppliedByDates = (type) => {
  const now = new Date();
  switch (type) {
    case "min":
      // 2 years ago
      now.setDate(now.getDate() - 365 * 2);
      return now.toISOString().split("T")[0];
    case "max":
      return now.toISOString().split("T")[0];
  }
};

const hashCode = (string: string) => {
  var hash = 0,
    i,
    chr;
  if (string.length === 0) return hash;
  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

const genAnchor = (
  searchParams: string,
  page: number = 1,
  filter?: number,
  groupMembers?: Array<number>
) => {
  const params = new URLSearchParams(searchParams);
  const existingFilters = params.get("filters")?.split(",").map(Number) || [];
  if (filter == -1) params.delete("filters");

  if (filter && filter > -1) {
    // limit to 1 filter per group
    const groupLimit = existingFilters.filter((ef) =>
      groupMembers.includes(ef) ? false : true
    );
    const newFilters = [...groupLimit, filter];
    params.set("filters", newFilters.join(","));
  }
  const path = window.location.pathname.split("/")[1];
  return `/${path}/${page}` + (params.get("filters") ? `?${params.toString()}`: "");
};

export {
  genAnchor,
  humanFileSize,
  getQueryStringParams,
  loadRemoteResource,
  getSuppliedByDates,
  hashCode,
};
